import { useEffect } from "react";
import { useNavigate, useParams } from "@tanstack/react-router";
import type { ModuleManifest } from "@praesto/contracts";

/**
 * When the user lands on /{tenantSlug}/{moduleId} without a sub-path,
 * redirect to the sub-route flagged `index: true` (or the first one).
 */
export function ModuleIndexRedirect({ manifest }: { manifest: ModuleManifest }) {
  const navigate = useNavigate();
  const { tenantSlug } = useParams({ from: "/$tenantSlug" }) as {
    tenantSlug: string;
  };

  useEffect(() => {
    const subs = manifest.subRoutes ?? [];
    const target = subs.find((s) => s.index) ?? subs[0];
    if (!target) return;
    void navigate({
      to: `/${tenantSlug}/${manifest.id}/${target.path}`,
    });
  }, [manifest, navigate, tenantSlug]);

  return <p className="p-6 text-caption text-fg-muted">Reindirizzamento…</p>;
}
